import { useCallback, useEffect, useState } from "react";

import { getFormattedTimeLeft } from "app/components/discountCampaign/DiscountBanner/utils/helpers";
import { useSeasonalCampaign } from "app/marketing/hooks/campaing-hooks/seasonal-campaign/useSeasonalCampaign";
import { useLocalStorage } from "app/pages/activation/hooks/helpers/useLocalStorage";
import { allTrackers } from "app/services/track/track";
import { getDateAsText } from "app/UtilitiesAndConstants/UtilityFunctions/timeAndDate";

const SEASONAL_CAMPAIGN_MODAL_STORAGE_KEY = "seasonal.campaign.modal.last.shown";

interface IUseSeasonalCampaignModalApi {
    isOpen: boolean;
    isUpgradedToAnnual: boolean;
    promoCode?: string;
    discountEndDate: string;
    handleClose: () => void;
    onCtaClick: () => void;
}

export const useSeasonalCampaignModal = (): IUseSeasonalCampaignModalApi => {
    const { promoCode, isUpgradedToAnnual, discountEndDate, handleCtaClick } = useSeasonalCampaign();

    const { getLocalStorage, setLocalStorage } = useLocalStorage();

    const todayAsText = getDateAsText();
    const modalState = getLocalStorage(SEASONAL_CAMPAIGN_MODAL_STORAGE_KEY);

    const [isDiscarded, setIsDiscarded] = useState(modalState === todayAsText);

    const formattedTimeLeft = getFormattedTimeLeft({ discountEndTime: discountEndDate });

    const handleClose = useCallback(() => {
        allTrackers.dispatchTrackEvent("pop up", "close", `discount popup/Flash Sale Q226/${formattedTimeLeft}`);
        setLocalStorage(SEASONAL_CAMPAIGN_MODAL_STORAGE_KEY, todayAsText);
        setIsDiscarded(true);
    }, [formattedTimeLeft, setLocalStorage, todayAsText]);

    const onCtaClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("internal link", "click", `discount popup/Flash Sale Q226/${formattedTimeLeft}`);
        handleCtaClick();
    }, [formattedTimeLeft, handleCtaClick]);

    useEffect(() => {
        if (!isDiscarded) {
            allTrackers.dispatchTrackEvent("pop up", "show", `discount popup/Flash Sale Q226/${formattedTimeLeft}`);
        }
    }, [formattedTimeLeft, isDiscarded]);

    return {
        isOpen: !isDiscarded,
        isUpgradedToAnnual,
        promoCode,
        discountEndDate,
        handleClose,
        onCtaClick,
    };
};
